// Moved here so web-server-common tests dont end up imporing Playbutton.styled and svg's
// which are not supported by web-server-common tests.
export const playOverlayClassName = 'Play-Overlay'
